<template>
  <!-- Error state: show minimal error UI -->
  <div v-if="hasError" class="fixed bottom-20 right-4 z-50">
    <div
      class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 shadow-lg max-w-xs"
    >
      <div class="flex items-start gap-2">
        <svg class="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        <div class="flex-1">
          <p class="text-sm font-medium text-red-800 dark:text-red-200">Chat Unavailable</p>
          <p class="text-xs text-red-600 dark:text-red-400 mt-1">
            An error occurred. Please refresh the page or try again.
          </p>
          <button
            class="mt-2 text-xs text-red-600 dark:text-red-400 underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-red-500 rounded"
            @click="retry"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Normal state: render actual chat widget -->
  <ChatWidgetCore v-else />
</template>

<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue';
import ChatWidgetCore from './ChatWidgetCore.vue';

const hasError = ref(false);

onErrorCaptured((err, instance, info) => {
  console.error('[ChatWidget] Error caught:', err);
  console.error('[ChatWidget] Component instance:', instance);
  console.error('[ChatWidget] Error info:', info);

  hasError.value = true;

  // Prevent error from propagating to parent components
  return false;
});

const retry = (): void => {
  hasError.value = false;
};
</script>
